import type { TranslationObj } from "$/utils/lang"

enum ECoachRatingType {
    PostModule = "post-module",
    Offboarding = "offboarding"
}

interface ICoachRatingModel {
    id: number
    questionKey: ECoachRatingType
    questions: {
        mainQuestion: TranslationObj
        oneStarQuestion: TranslationObj
        twoStarQuestion: TranslationObj
        threeStarQuestion: TranslationObj
        fourStarQuestion: TranslationObj
        fiveStarQuestion: TranslationObj
    }
    isRequired: boolean
    productTypeId: number
    freeResponsePrompt: string
}

export { ECoachRatingType }
export type { ICoachRatingModel }
